import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { customFilterDropdown, stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Popconfirm,
  Form,
  Modal,
  message,
  Input, Checkbox,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  HomeOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  DatabaseOutlined,
  WarningOutlined,
  CloseOutlined
} from "@ant-design/icons";
import {
  addCustomer,
  deleteCustomers,
  getCustomers,
  updateCustomers,
  updateCustomerStatus,
} from "../../store/actions/customers.js";
import { Spinner } from "reactstrap";
import CustomerForm from "./CustomerForm.js";
import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
import CustomToggleSwitch from "../../components/CustomToggleSwitch.js";
import moment from "moment-timezone";

// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
const { Title, Text } = Typography;

const Users = () => {
  document.title = "Customers List";
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const dispatch = useDispatch();
  const customersOrders = useSelector((state) => state.customers.list);
  const [form] = Form.useForm();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteComfirmModalVisible, setDeleteComfirmModalVisible] =
    useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [isModalVisibleDelete, setIsModalVisibleDelete] = useState(false);
  const [deleteInput, setDeleteInput] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCustomerss = async () => {
      try {
        await dispatch(getCustomers());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchCustomerss();
  }, [dispatch]);

  const handleCreate = async (values) => {
    try {
      if (selectedRecord) {
        // ✅ UPDATE MODE - Create clean update payload
        const updatePayload = {
          id: selectedRecord.id, // ID is required for update
          name: values.name,
          mobile: values.mobile,
          contactName: values.contactName,
          contactMobile: values.contactMobile,
          email: values.email,
          username: values.email, // ✅ Email as username
          address: values.address,
          gstin: values.gstin,
          cityId: values.cityId,
        };

        // Only include password if user wants to change it (optional)
        if (values.password && values.password.trim() !== "") {
          updatePayload.password = values.password;
        }

        await dispatch(updateCustomers(updatePayload, form));
      } else {
        // ✅ ADD MODE
        // Remove limit from add payload too
        delete values.limit; // Remove limit
        values.username = values.email; // ✅ Email as username

        await dispatch(addCustomer(values, form));
      }
      await dispatch(getCustomers());
    } catch (error) {
      console.error("Failed to save customer:", error);
    } finally {
      setSelectedRecord(null);
      setIsModalVisible(false);
    }
  };

  const handleChangeStatus = async (id, status) => {
    const formData = new FormData();

    formData.append("id", id);
    formData.append("status", status);
    console.log("id", id, status);
    await dispatch(updateCustomerStatus(id, status));
    await dispatch(getCustomers());
  };

  // const handleDelete = async (key) => {
  //   await dispatch(deleteCustomers(key));
  // };

  // const handleDelete = async (item) => {
  //   setItemToDelete(item);
  //   setDeleteModalVisible(true);
  // };
  const handleConfirmDelete = async (item) => {
    setItemToDelete(item);
    setDeleteComfirmModalVisible(true);
  };

  const confirmDelete = async () => {
    try {
      await dispatch(deleteCustomers(itemToDelete.id));
      await dispatch(getCustomers());
      setDeleteComfirmModalVisible(false);
    } catch (error) {
      message.error("An error occurred while deleting the item");
    }
  };
  useEffect(() => {
    const fetchAmazonOrders = async () => {
      try {
        await dispatch(getCustomers());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchAmazonOrders();
  }, [dispatch]);

  const renderCell = (text) => (text ? text : "");
  const userRenderCell = (text) => (text ? text : "User");
  let columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: stringSorter("name"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      filters: [
        ...[...new Set((customersOrders || []).map((order) => order.mobile))]
          .filter((mobile) => mobile !== null && mobile !== undefined)
          .map((mobile) => ({
            text: mobile || "N/A",
            value: mobile,
          })),
      ],
      onFilter: (value, record) => record.mobile === value,
      // sorter: stringSorter("mobile"),
      // sortDirections: ["ascend", "descend"],
      render: (text, record) => (
        <span style={{ height: "20px", lineHeight: "15px" }}>
          {record.mobile || "N/A"}
        </span>
        // <span className="badge rounded-pill bg-info text-white" style={{ height: '20px', lineHeight: '15px' }} >
        //   {text || 'N/A'}
        // </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      filters: [
        ...[...new Set((customersOrders || []).map((order) => order.email))]
          .filter((email) => email !== null && email !== undefined)
          .map((email) => ({
            text: email || "N/A",
            value: email,
          })),
      ],
      onFilter: (value, record) => record.email === value,
      sorter: stringSorter("email"),
      sortDirections: ["ascend", "descend"],
      render: (text, record) => (
        // <span className="badge rounded-pill bg-primary text-white" style={{ height: '20px', lineHeight: '15px' }} >{record.email || 'N/A'}</span>
        <span style={{ height: "20px", lineHeight: "15px" }}>
          {record.email || "N/A"}
        </span>
      ),
    },
    {
      title: "GSTIN",
      dataIndex: "gstin",
      key: "gstin",
      sorter: stringSorter("gstin"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "CODE",
      dataIndex: "code",
      key: "code",
      sorter: stringSorter("code"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      sorter: stringSorter("address"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Limit",
      dataIndex: "limit",
      key: "limit",
      sorter: stringSorter("limit"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "startDate",
      dataIndex: "startDate",
      key: "startDate",
      sorter: stringSorter("startDate"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "amount",
      dataIndex: "amount",
      key: "amount",
      sorter: stringSorter("amount"),
      sortDirections: ["ascend", "descend"],
    },
    // {
    //   title: "city",
    //   dataIndex: "city",
    //   key: "city",
    //   // filterDropdown: customFilterDropdown,
    //   // onFilter: (value, record) => record.city.includes(value),
    //   // sorter: stringSorter("city"),
    //   sortDirections: ["ascend", "descend"],
    //   render: (text, record) => (
    //       // <span className="badge rounded-pill bg-primary text-white" style={{ height: '20px', lineHeight: '15px' }} >{record.city}</span>
    //       <span style={{ height: '20px', lineHeight: '15px' }} >{record.city}</span>
    //   ),
    // },
    // {
    //   title: "State",
    //   dataIndex: "state",
    //   key: "state",
    //   filters: [
    //     ...[...new Set((customersOrders || []).map(order => order.state))]
    //         .filter(state => state !== null && state !== undefined)
    //         .map(state => ({
    //             text: state || 'N/A',
    //             value: state,
    //         })),
    // ],
    // // onFilter: (value, record) => record.shipToState === value,
    // // sorter: stringSorter("shipToState"),
    // sortDirections: ["ascend", "descend"],
    // },
    // {
    //   title: "Country",
    //   dataIndex: "country",
    //   key: "country",
    //   filters: [
    //     ...[...new Set((customersOrders || []).map(order => order.country))]
    //         .filter(country => country !== null && country !== undefined)
    //         .map(country => ({
    //             text: country || 'N/A',
    //             value: country,
    //         })),
    // ],
    // // onFilter: (value, record) => record.country === value,
    // // sorter: stringSorter("country"),
    // sortDirections: ["ascend", "descend"],
    // },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        moment(date).isValid()
          ? moment(date).format("YYYY-MM-DD HH:mm:ss")
          : "",
      sorter: (a, b) =>
        moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
          ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
      key: "createdByName",
      sorter: stringSorter("createdByName"),
      sortDirections: ["ascend", "descend"],
      render: userRenderCell,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (date) =>
        moment(date).isValid()
          ? moment(date).format("YYYY-MM-DD HH:mm:ss")
          : "",
      sorter: (a, b) =>
        moment(a.updatedAt).isValid() && moment(b.updatedAt).isValid()
          ? moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Updated By",
      dataIndex: "updatedByName",
      key: "updatedByName",
      sorter: stringSorter("updatedByName"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <CustomToggleSwitch
          record={record}
          onChangeStatus={handleChangeStatus}
        />
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button>
          {/* <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record.key)}
          >
            <Button type="link" danger><DeleteOutlined /></Button>
          </Popconfirm> */}
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => showModal(record)}
          >
          </Button>
          {/* {record?.status ? (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => showModal(record)}
            >
            </Button>
          ) : (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleConfirmDelete(record)}
            >
            </Button>
          )} */}
        </Space>
      ),
    },
  ];
  columns = enhanceColumnsWithFilters(columns);


  const showModal = (item) => {
    setIsModalVisibleDelete(true);
    setItemToDelete(item);
    console.log("customer", item);
    setDeleteInput('');
    setIsConfirmed(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    setTimeout(async () => {
      await dispatch(deleteCustomers(itemToDelete.id));
      await dispatch(getCustomers());
      setLoading(false);
      setIsModalVisibleDelete(false);
    }, 1500);
  };

  const handleCancel = () => {
    setIsModalVisibleDelete(false);
  };

  const canDelete = deleteInput === 'DELETE' && isConfirmed;

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Customer</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Manage Customers
              </Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                ADD NEW CUSTOMER
              </Button>
            </Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={customersOrders.map((item) => ({
                ...item,
                key: item.id,
                status: item.status ? 1 : 0,
              }))}
              columns={columns}
            />
          )}
        </Space>
      </Card>
      <CustomerForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => setIsModalVisible(false)}
        record={selectedRecord}
        form={form}
      />

      <Modal
        title="Confirm Delete"
        zIndex={100000000}
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setDeleteModalVisible(false)}>
            Ok
          </Button>,
          // <Button key="delete" danger onClick={confirmDelete}>
          //   Delete
          // </Button>,
        ]}
      >
        <p>Can not remove active Customer</p>
        {itemToDelete && (
          <p>
            <strong>Record Name:</strong> {itemToDelete.name}
          </p>
        )}
        <p style={{ color: "red" }}>
          <b>Note: </b> Delete Customer will remove all the data including
          database of customer{" "}
        </p>
      </Modal>

      <Modal
        title="Delete Customer"
        zIndex={100000000}
        visible={deleteComfirmModalVisible}
        onCancel={() => setDeleteComfirmModalVisible(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => setDeleteComfirmModalVisible(false)}
          >
            Cancel
          </Button>,
          <Button key="delete" danger onClick={confirmDelete}>
            Delete
          </Button>,
        ]}
      >
        <h4>Are you sure you want to delete customer?</h4>
        {itemToDelete && (
          <p>
            <strong>Customer Name:</strong> {itemToDelete.name}
          </p>
        )}
        <p style={{ color: "red" }}>
          <b>Note: </b> Delete Customer will remove all the data including
          database of customer{" "}
        </p>
      </Modal>


      <Modal
        open={isModalVisibleDelete}
        onCancel={handleCancel}
        footer={null}
        width={700}
        closeIcon={<CloseOutlined style={{ color: 'white', fontSize: '16px' }} />}
        styles={{
          header: {
            background: '#dc3545',
            padding: '16px 24px',
            marginBottom: 0
          },
          body: { padding: '24px' },
          content: { padding: 0 }
        }}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <ExclamationCircleOutlined style={{ color: 'white', fontSize: '20px' }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <span style={{ color: 'white', fontSize: '16px', fontWeight: '600' }}>
                Delete Customer Account
              </span>
              <Text style={{ color: 'white', fontSize: '13px' }}>
                This action cannot be undone.
              </Text>
            </div>
          </div>
        }
      >
        {/* <div style={{ color: 'white', background: '#dc3545', padding: '0 24px 16px 24px', marginTop: '-24px' }}>
          <Text style={{ color: 'white', fontSize: '13px' }}>
            This action cannot be undone.
          </Text>
        </div> */}

        {/* Warning Section */}
        <div style={{
          background: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '6px',
          padding: '16px',
          marginBottom: '24px'
        }}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
            <WarningOutlined style={{ color: '#856404', fontSize: '16px', marginTop: '2px' }} />
            <Text strong style={{ color: '#856404', fontSize: '14px' }}>
              Warning: Permanent Deletion
            </Text>
          </div>
          <Text style={{ color: '#856404', fontSize: '13px', display: 'block', marginBottom: '8px' }}>
            You are about to permanently delete this customer account and all associated data. This includes:
          </Text>
          <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', color: '#856404' }}>
            <li style={{ marginBottom: '4px', fontSize: '13px' }}>Customer profile and personal information</li>
            <li style={{ marginBottom: '4px', fontSize: '13px' }}>All database records</li>
            <li style={{ marginBottom: '4px', fontSize: '13px' }}>Transaction history and activity logs</li>
            <li style={{ fontSize: '13px' }}>Associated files and documents</li>
          </ul>
        </div>

        {/* Customer Information */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
            <UserOutlined style={{ color: '#595959', fontSize: '14px' }} />
            <Text strong style={{ fontSize: '14px' }}>Customer Information</Text>
          </div>

          <div style={{ background: '#fafafa', border: '1px solid #e8e8e8', borderRadius: '6px', padding: '16px' }}>
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                  <UserOutlined style={{ color: '#000000', fontSize: '12px' }} />
                  <Text style={{ color: '#000000', fontSize: '12px' }}>
                    {itemToDelete?.contactName}
                  </Text>
                </div>
                {/* <Text style={{ fontSize: '14px', display: 'block', paddingLeft: '20px' }}>
                  {customerData.name}
                </Text> */}
              </div>

              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                  <MailOutlined style={{ color: '#000000', fontSize: '12px' }} />
                  <Text style={{ color: '#000000', fontSize: '12px' }}>
                    {itemToDelete?.email}
                  </Text>
                </div>
                {/* <Text style={{ fontSize: '14px', display: 'block', paddingLeft: '20px' }}>
                  {customerData.email}
                </Text> */}
              </div>

              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                  <PhoneOutlined style={{ color: '#000000', fontSize: '12px' }} />
                  <Text style={{ color: '#000000', fontSize: '12px' }}>
                    {itemToDelete?.mobile}
                  </Text>
                </div>
                {/* <Text style={{ fontSize: '14px', display: 'block', paddingLeft: '20px' }}>
                  {customerData.phone}
                </Text> */}
              </div>

              {/* <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <EnvironmentOutlined style={{ color: '#8c8c8c', fontSize: '12px' }} />
                  <Text style={{ color: '#8c8c8c', fontSize: '12px', textTransform: 'uppercase' }}>
                    Address
                  </Text>
                </div>
                <Text style={{ fontSize: '14px', display: 'block', paddingLeft: '20px' }}>
                  {customerData.address}
                </Text>
              </div> */}

              {/* <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <DatabaseOutlined style={{ color: '#8c8c8c', fontSize: '12px' }} />
                  <Text style={{ color: '#8c8c8c', fontSize: '12px', textTransform: 'uppercase' }}>
                    Database Records
                  </Text>
                </div>
                <Text strong style={{ fontSize: '14px', display: 'block', paddingLeft: '20px' }}>
                  {customerData.recordsCount} records will be permanently deleted
                </Text>
              </div> */}
            </Space>
          </div>
        </div>

        {/* Confirmation Input */}
        <div style={{ marginBottom: '20px' }}>
          <Text style={{ fontSize: '13px', display: 'block', marginBottom: '8px' }}>
            Type <Text strong style={{ color: '#dc3545' }}>DELETE</Text> to confirm
          </Text>
          <Input
            placeholder="Type DELETE here"
            value={deleteInput}
            onChange={(e) => setDeleteInput(e.target.value)}
            size="large"
            style={{ fontSize: '14px' }}
          />
        </div>

        {/* Checkbox Confirmation */}
        <div style={{ marginBottom: '24px' }}>
          <Checkbox
            checked={isConfirmed}
            onChange={(e) => setIsConfirmed(e.target.checked)}
          >
            <Text style={{ fontSize: '13px' }}>
              I understand that this action is permanent and irreversible. All customer data and database records will be permanently deleted.
            </Text>
          </Checkbox>
        </div>

        {/* Footer */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '16px',
          borderTop: '1px solid #f0f0f0'
        }}>
          <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>
            {/* Customer ID: {customerData.id} */}
          </Text>
          <Space>
            <Button onClick={handleCancel} size="large">
              Cancel
            </Button>
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              onClick={handleDelete}
              disabled={!canDelete}
              loading={loading}
              size="large"
            >
              Permanently Delete
            </Button>
          </Space>
        </div>
      </Modal>
    </div>
  );
};

export default Users;
